var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOnOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "820.000000pt",
    height: "655.000000pt",
    viewBox: "0 0 820.000000 655.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,655.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1332 5917 c-122 -122 -222 -227 -222 -233 0 -7 1241 -1249 2758 -2762 1516 -1512 2761 -2754 2765 -2758 9 -9 457 435 457 452 0 12 -5517 5524 -5529 5524 -3 0 -106 -100 -229 -223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3755 5764 c-268 -27 -516 -71 -720 -129 -138 -39 -356 -113 -370 -126 -11 -11 596 -619 618 -619 8 0 39 11 68 24 250 110 597 168 879 146 695 -52 1296 -458 1596 -1076 236 -485 254 -1043 52 -1552 l-41 -104 384 -384 c211 -211 388 -384 394 -384 13 0 251 208 412 360 339 322 727 768 992 1139 93 130 94 103 -9 256 -239 357 -628 814 -941 1106 -822 767 -1657 1195 -2574 1320 -113 15 -218 21 -425 24 -151 1 -293 1 -315 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383 4719 c-139 -118 -479 -460 -610 -614 -292 -342 -688 -918 -664 -964 36 -66 350 -459 526 -656 147 -165 461 -482 630 -635 798 -723 1616 -1160 2405 -1284 404 -64 860 -38 1250 70 166 47 494 164 540 194 12 8 -42 67 -270 295 l-286 286 -54 -24 c-251 -111 -602 -169 -882 -147 -615 49 -1142 359 -1478 870 -224 341 -336 780 -302 1183 20 222 66 419 142 595 l29 67 -427 428 c-235 235 -430 427 -434 427 -4 0 -56 -41 -115 -91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3956 4211 c-6 -9 1189 -1201 1203 -1201 15 0 22 146 11 241 -15 136 -44 240 -101 359 -149 313 -431 530 -772 595 -86 16 -332 21 -341 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3026 3211 c-11 -128 19 -317 73 -452 97 -245 276 -442 509 -562 165 -85 322 -120 510 -115 l112 3 -598 598 -599 599 -7 -71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOnOff);
export default __webpack_public_path__ + "static/media/eye-on-off.c41e71c7316407116eb5992716b14001.svg";
export { ForwardRef as ReactComponent };